/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/function-component-definition */
/* eslint-disable @typescript-eslint/no-unused-vars */
import type { DatePickerProps } from 'antd'
import { DatePicker, Space, ConfigProvider } from 'antd'
import React from 'react'
import { Dayjs } from 'dayjs'
import { colors } from '../../theme'

interface Props {
  handleDataSelecionada: (data: string) => void
  size: string
  background?: boolean
  dayjs?: Dayjs | null
}

const DatesPicker: React.FC<Props> = ({
  handleDataSelecionada,
  size,
  background,
  dayjs,
}) => {
  const onChange: DatePickerProps['onChange'] = (date, dateString) => {
    handleDataSelecionada(dateString)
  }
  return (
    <Space direction="vertical">
      <DatePicker
        style={{
          backgroundColor: background ? colors.surface : colors.grey100,
          width: size,
        }}
        onChange={onChange}
        defaultValue={dayjs || undefined}
        format="DD/MM/YYYY"
      />

      {/* <DatePicker onChange={onChange} picker="week" />
      <DatePicker onChange={onChange} picker="month" />
      <DatePicker onChange={onChange} picker="quarter" />
      <DatePicker onChange={onChange} picker="year" /> */}
    </Space>
  )
}

export default DatesPicker
